"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FThemeBuilderCheckbox = void 0;
const react_1 = __importDefault(require("react"));
const FThemeBuilderCheckbox = ({ name, label, prefix = "", selectedFieldName, setFieldName, onChange = () => {
}, id = "", className = "", checked = false, }) => {
    return (react_1.default.createElement("div", { className: `f-input-group f-input-checkbox-group` },
        react_1.default.createElement("div", { className: "f-input-checkbox" },
            react_1.default.createElement("input", { type: "checkbox", id: `${name}_id`, name: `${name}`, checked: selectedFieldName === name ? true : false, onChange: onChange }),
            react_1.default.createElement("label", { htmlFor: `${name}_id` }, label))));
};
exports.FThemeBuilderCheckbox = FThemeBuilderCheckbox;
//# sourceMappingURL=FthemeBuilderInputCheckbox.js.map